/* LosT Found クレジット: 毎日のボーナス（ホイール）
   抽選と付与はサーバー（/apps/credits）が行う。ここはサーバーが決めた枠に止めて、結果を表示するだけ。 */
(() => {
  const root = document.querySelector('[data-lfc]');
  if (!root) return;
  let C;
  try {
    C = JSON.parse(root.querySelector('[data-lfc-config]').textContent);
  } catch (e) {
    return;
  }
  const T = C.t;
  const API = '/apps/credits';
  const SVG = 'http://www.w3.org/2000/svg';
  const $ = (sel) => root.querySelector(sel);
  const panel = $('.lfc__panel');
  const rotor = $('[data-lfc-rotor]');
  const pointer = $('[data-lfc-pointer]');
  const info = $('[data-lfc-info]');
  const spinBtn = $('[data-lfc-spin]');
  const loginBtn = $('[data-lfc-login]');
  const dateEl = $('[data-lfc-date]');
  const oddsView = $('[data-lfc-odds]');
  const oddsOpen = $('[data-lfc-odds-open]');
  const oddsClose = $('[data-lfc-odds-close]');
  const oddsRows = $('[data-lfc-odds-rows]');
  const rulesEl = $('[data-lfc-rules]');
  const reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const isJa = C.locale === 'ja';
  const spinLabel = spinBtn.textContent;
  const closeLabel = $('.lfc__close').textContent;

  // ---- 保存（プライベートブラウズ等で使えなくても動くように）
  const storageGet = (kind, key) => {
    try { return window[kind].getItem(key); } catch (e) { return null; }
  };
  const storageSet = (kind, key, value) => {
    try { window[kind].setItem(key, value); } catch (e) { /* 保存できなくても続ける */ }
  };
  const storageDel = (kind, key) => {
    try { window[kind].removeItem(key); } catch (e) { /* 同上 */ }
  };

  // ---- 見本表示（未公開テーマのプレビューでだけ）: ?lf_bonus_demo=spin|bonus|claimed|limit|new|cap|guest|usd|error|reset|off
  let demo = null;
  const role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
  if (role && role !== 'main') {
    const q = new URLSearchParams(location.search).get('lf_bonus_demo');
    if (q === 'off') storageDel('sessionStorage', 'lfc:demo');
    else if (q === 'reset') storageDel('sessionStorage', 'lfc:demo-claim');
    else if (q) {
      storageSet('sessionStorage', 'lfc:demo', q);
      storageDel('sessionStorage', 'lfc:demo-claim');
    }
    demo = storageGet('sessionStorage', 'lfc:demo');
  }

  // ---- 書式
  const fill = (s, map) => Object.keys(map).reduce((out, k) => out.split('__' + k.toUpperCase() + '__').join(map[k]), s);
  const money = (minor, currency) => {
    if (currency === 'JPY') return '¥' + Math.round(minor).toLocaleString('ja-JP');
    const v = minor / 100;
    const whole = minor % 100 === 0;
    try {
      return new Intl.NumberFormat(isJa ? 'ja-JP' : 'en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(v);
    } catch (e) {
      return v.toFixed(2) + ' ' + currency;
    }
  };
  const fmt = (opts, d) => {
    try { return new Intl.DateTimeFormat(isJa ? 'ja-JP' : 'en-US', opts).format(d); } catch (e) { return d.toISOString().slice(0, 16).replace('T', ' '); }
  };
  const dateTime = (iso) => fmt({ month: isJa ? 'long' : 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }, new Date(iso));
  const dateOnly = (iso) => fmt({ month: isJa ? 'long' : 'short', day: 'numeric' }, new Date(iso));
  // 'YYYY-MM-DD'（日本時間の日付）に日数を足した日付
  const dayPlus = (day, n) => {
    const [y, m, d] = day.split('-').map(Number);
    return fmt({ month: isJa ? 'long' : 'short', day: 'numeric', timeZone: 'UTC' }, new Date(Date.UTC(y, m - 1, d + n)));
  };
  const jstDay = () => new Date(Date.now() + 9 * 3600e3).toISOString().slice(0, 10);
  const percent = (p) => {
    try { return new Intl.NumberFormat(isJa ? 'ja-JP' : 'en-US', { style: 'percent', maximumFractionDigits: 2 }).format(p); } catch (e) { return Math.round(p * 1000) / 10 + '%'; }
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // ---- ホイール
  const R_OUT = 112;
  const R_IN = 25;
  const R_LABEL = 77;
  let order = []; // order[k] = k番目の枠に入る賞（サーバーの prizes の番号）
  let segs = [];
  let labels = [];
  let segAngle = 60;
  let angle = 0;

  const svgEl = (name, attrs) => {
    const el = document.createElementNS(SVG, name);
    Object.keys(attrs).forEach((k) => el.setAttribute(k, attrs[k]));
    return el;
  };
  const polar = (r, deg) => {
    const a = (deg * Math.PI) / 180;
    return [+(r * Math.sin(a)).toFixed(3), +(-r * Math.cos(a)).toFixed(3)];
  };
  // 金額の文字は回っている間も常に正立させる
  const setAngle = (a) => {
    angle = a;
    rotor.setAttribute('transform', 'rotate(' + a.toFixed(3) + ')');
    labels.forEach((t, k) => {
      t.setAttribute('transform', 'rotate(' + k * segAngle + ') translate(0 ' + -R_LABEL + ') rotate(' + (-(k * segAngle + a)).toFixed(3) + ')');
    });
  };
  const mod = (a, n) => ((a % n) + n) % n;

  function buildWheel(prizes, currency) {
    const key = currency + ':' + prizes.join(',');
    if (rotor.getAttribute('data-key') === key) return;
    rotor.setAttribute('data-key', key);
    rotor.textContent = '';
    // 大きい額と小さい額が交互に並ぶように
    const asc = prizes.map((_, i) => i).sort((a, b) => prizes[a] - prizes[b]);
    order = [];
    for (let lo = 0, hi = asc.length - 1; lo <= hi; ) {
      order.push(asc[hi--]);
      if (lo <= hi) order.push(asc[lo++]);
    }
    const n = order.length;
    segAngle = 360 / n;
    segs = order.map((_, k) => {
      const s = k * segAngle - segAngle / 2;
      const e = k * segAngle + segAngle / 2;
      const [x1, y1] = polar(R_OUT, s);
      const [x2, y2] = polar(R_OUT, e);
      const [x3, y3] = polar(R_IN, e);
      const [x4, y4] = polar(R_IN, s);
      const large = segAngle > 180 ? 1 : 0;
      const path = svgEl('path', {
        class: 'lfc__seg',
        d: `M${x1} ${y1}A${R_OUT} ${R_OUT} 0 ${large} 1 ${x2} ${y2}L${x3} ${y3}A${R_IN} ${R_IN} 0 ${large} 0 ${x4} ${y4}Z`,
      });
      rotor.appendChild(path);
      return path;
    });
    for (let d = 0; d < 360; d += 6) {
      if (mod(d + segAngle / 2, segAngle) < 0.01) continue; // 枠の境目は線があるので省く
      const [x1, y1] = polar(R_OUT - 5, d);
      const [x2, y2] = polar(R_OUT, d);
      rotor.appendChild(svgEl('line', { class: 'lfc__tick', x1, y1, x2, y2 }));
    }
    labels = order.map((pi, k) => {
      const t = svgEl('text', { class: 'lfc__label', 'text-anchor': 'middle', dy: '0.36em' });
      t.textContent = money(prizes[pi], currency);
      rotor.appendChild(t);
      return t;
    });
    rotor.appendChild(svgEl('circle', { class: 'lfc__ring', r: R_OUT }));
    setAngle(angle);
  }

  function markWin(k) {
    segs.forEach((s, i) => s.classList.toggle('is-win', i === k));
    labels.forEach((l, i) => l.classList.toggle('is-win', i === k));
  }
  function markOff(prizes, limit) {
    labels.forEach((l, k) => l.classList.toggle('is-off', !!limit && prizes[order[k]] > limit.leftMinor));
  }
  // k番目の枠が上の針の下に来る角度（枠の中で少しずらす）
  const angleFor = (k, jitter) => -k * segAngle + jitter * segAngle * 0.34;

  // 回す: 返事が来るまで一定の速さで回し、来たら結果の枠へ減速して止める
  let anim = null;
  function startRun() {
    const W = 780; // 度/秒
    const ACC = 0.45;
    const t0 = performance.now();
    const a0 = angle;
    let kick = 0;
    let lastNow = t0;
    let lastB = Math.floor((angle + segAngle / 2) / segAngle);
    anim = { target: null, minRun: 0.9, onDone: null };
    const step = (now) => {
      if (!anim) return;
      const t = (now - t0) / 1000;
      let a;
      let done = false;
      if (!anim.stop) {
        a = t < ACC ? a0 + (0.5 * W * t * t) / ACC : a0 + 0.5 * W * ACC + W * (t - ACC);
        if (anim.target != null && t >= anim.minRun) {
          // 速さが途切れないように、減速の長さを残りの距離から決める（3次のイーズアウト）
          let D = mod(anim.target - a, 360);
          while (D < (W * 2.8) / 3) D += 360;
          anim.stop = { ts: now, as: a, D, Td: (3 * D) / W };
        }
      } else {
        const s = anim.stop;
        const u = Math.min(1, (now - s.ts) / 1000 / s.Td);
        a = s.as + s.D * (1 - Math.pow(1 - u, 3));
        done = u >= 1;
      }
      setAngle(a);
      // 枠の境目が針を通るたびに針が少し跳ねる
      const b = Math.floor((a + segAngle / 2) / segAngle);
      if (b !== lastB) {
        kick = 1;
        lastB = b;
      }
      kick *= Math.exp(-(now - lastNow) / 70);
      lastNow = now;
      pointer.setAttribute('transform', 'rotate(' + (-16 * kick).toFixed(2) + ' 0 -125)');
      if (done) {
        pointer.removeAttribute('transform');
        const cb = anim.onDone;
        anim = null;
        if (cb) cb();
        return;
      }
      requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  function stopAt(target, cb) {
    if (!anim) {
      setAngle(target);
      cb();
      return;
    }
    anim.target = target;
    anim.onDone = cb;
  }

  // ---- 状態の取得
  let state = null;
  let busy = false;
  let lastFocus = null;

  const CACHE_KEY = 'lfc:status';
  function cacheStatus(s) {
    if (!s || !s.loggedIn) return;
    storageSet('sessionStorage', CACHE_KEY, JSON.stringify({ at: Date.now(), customer: C.customer, day: s.day, eligible: s.eligible, claimed: s.claimed, enabled: s.enabled }));
  }
  function cachedStatus() {
    try {
      const c = JSON.parse(storageGet('sessionStorage', CACHE_KEY) || 'null');
      if (c && c.customer === C.customer && c.day === jstDay() && Date.now() - c.at < 5 * 60e3) return c;
    } catch (e) { /* 壊れていたら取り直す */ }
    return null;
  }

  async function request(path, method) {
    const r = await fetch(API + path + '?cur=' + encodeURIComponent(C.currency || ''), {
      method,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    let body = null;
    try { body = await r.json(); } catch (e) { body = null; }
    return { http: r.status, body };
  }

  async function fetchStatus() {
    if (demo) return demoStatus();
    const { http, body } = await request('/status', 'GET');
    if (http === 429) return { rateLimited: true };
    if (!body || !body.ok) throw new Error((body && body.error) || 'http ' + http);
    return body;
  }

  // ---- 表示
  function rows(s) {
    const list = [];
    list.push([T.streakLabel, fill(T.streakValue, { count: s.streak || 0 })]);
    list.push([T.balanceLabel, money(s.balanceMinor || 0, s.currency)]);
    const next = (s.upcoming || []).filter((u) => u.currency === s.currency).sort((a, b) => (a.dueAt < b.dueAt ? -1 : 1))[0];
    if (next) list.push([T.upcomingLabel, fill(T.upcomingValue, { amount: money(next.amountMinor, next.currency), date: dateOnly(next.dueAt) })]);
    return '<dl class="lfc__stats">' + list.map(([k, v]) => '<div><dt>' + esc(k) + '</dt><dd>' + esc(v) + '</dd></div>').join('') + '</dl>';
  }
  const p = (cls, text) => '<p class="' + cls + '">' + esc(text) + '</p>';

  function resultHtml(s, r, fresh) {
    const parts = [];
    if (fresh) {
      parts.push(p('lfc__text', T.added));
      parts.push(p('lfc__text', T.use));
      if (s.rules && s.rules.expiresDays) parts.push(p('lfc__text', fill(T.expires, { date: dayPlus(r.day, s.rules.expiresDays) })));
    } else {
      parts.push(p('lfc__text', T.claimed));
      if (s.resetAt) parts.push(p('lfc__text', fill(T.next, { time: dateTime(s.resetAt) })));
    }
    if (r.bonusMinor > 0) parts.push(p('lfc__note', fill(T.bonusIncluded, { count: r.streak, amount: money(r.bonusMinor, r.currency) })));
    if (r.note === 'cap') parts.push(p('lfc__note', fill(T.noteCap, { amount: money(r.bonusMinor, r.currency) })));
    if (r.note === 'budget') parts.push(p('lfc__note', fill(T.noteBudget, { amount: money(r.bonusMinor, r.currency) })));
    return '<div class="lfc__result"><p class="lfc__amount">' + esc(money(r.amountMinor, r.currency)) + '</p><div class="lfc__result-text">' + parts.join('') + '</div></div>';
  }

  function reasonText(s, reason, availableAt) {
    const tpl = T.reasons[reason];
    if (!tpl) return T.error;
    return fill(tpl, {
      count: (s && s.rules && s.rules.minAccountAgeHours) || 24,
      time: availableAt ? dateTime(availableAt) : '',
      amount: s && s.month && s.month.capMinor != null ? money(s.month.capMinor, s.currency) : '',
    });
  }

  function renderOdds(s) {
    if (!s || !s.odds || !s.odds.length) {
      oddsOpen.hidden = true;
      showOdds(false);
      return;
    }
    oddsOpen.hidden = false;
    oddsRows.innerHTML = s.odds
      .slice()
      .sort((a, b) => a.minor - b.minor)
      .map((o) => '<tr' + (o.probability === 0 ? ' class="is-off"' : '') + '><td>' + esc(money(o.minor, s.currency)) + '</td><td>' + (o.probability === 0 ? '—' : esc(percent(o.probability))) + '</td></tr>')
      .join('');
    const r = s.rules || {};
    const rules = [T.rules.once];
    if (r.streakEvery && r.streakBonusMinor) rules.push(fill(T.rules.streak, { count: r.streakEvery, amount: money(r.streakBonusMinor, s.currency) }));
    if (r.expiresDays) rules.push(fill(T.rules.expires, { count: r.expiresDays }));
    if (r.monthlyCapMinor != null) rules.push(fill(T.rules.cap, { amount: money(r.monthlyCapMinor, s.currency) }));
    if (r.minAccountAgeHours) rules.push(fill(T.rules.age, { count: r.minAccountAgeHours }));
    rules.push(T.rules.odds);
    rulesEl.innerHTML = rules.map((x) => '<li>' + esc(x) + '</li>').join('');
  }

  // 「確率とルール」は内容と入れ替えて表示する（下に広げるとパネルが縦に長くなるため）
  function showOdds(on) {
    const was = root.classList.contains('is-odds');
    root.classList.toggle('is-odds', on);
    oddsView.hidden = !on;
    if (on && !was) oddsClose.focus();
    else if (!on && was && !root.hidden) oddsOpen.focus();
  }

  function setButton(mode) {
    // mode: spin | wait | close | login | none
    loginBtn.hidden = mode !== 'login';
    spinBtn.hidden = mode === 'login' || mode === 'none';
    spinBtn.disabled = mode === 'wait';
    spinBtn.textContent = mode === 'close' ? closeLabel : spinLabel;
    spinBtn.setAttribute('data-mode', mode);
  }

  function updateCount(s) {
    const on = !!(s && s.loggedIn !== false && s.enabled && s.eligible && !s.claimed);
    document.querySelectorAll('[data-lfc-count]').forEach((el) => {
      el.hidden = !on;
    });
  }

  function render(s) {
    state = s;
    dateEl.textContent = ((s && s.day) || jstDay()).replace(/-/g, '.');
    if (!s || s.error) {
      info.innerHTML = p('lfc__note', s && s.rateLimited ? T.rateLimited : T.error);
      setButton('close');
      renderOdds(null);
      return;
    }
    buildWheel(s.prizes || [], s.currency);
    renderOdds(s);
    markOff(s.prizes || [], s.claimed ? null : s.limit);

    if (!s.loggedIn) {
      markWin(-1);
      info.innerHTML = p('lfc__text', T.guest);
      setButton('login');
      return;
    }
    if (s.claimed && s.result) {
      const k = order.indexOf(s.result.index);
      if (k >= 0 && !anim) {
        setAngle(angleFor(k, 0));
        markWin(k);
      }
      info.innerHTML = resultHtml(s, s.result, false) + rows(s);
      setButton('close');
      return;
    }
    markWin(-1);
    const notes = [];
    if (!s.enabled) {
      notes.push(p('lfc__note', T.error));
    } else if (!s.eligible) {
      notes.push(p('lfc__text', reasonText(s, s.reason, s.availableAt)));
    } else {
      const next = (s.streak || 0) + 1;
      const r = s.rules || {};
      if (r.streakEvery && r.streakBonusMinor && next % r.streakEvery === 0) {
        notes.push(p('lfc__note', fill(T.bonusToday, { count: next, amount: money(r.streakBonusMinor, s.currency) })));
      }
      if (s.limit) notes.push(p('lfc__note', fill(s.limit.by === 'cap' ? T.limitCap : T.limitBudget, { amount: money(s.limit.leftMinor, s.currency) })));
    }
    info.innerHTML = rows(s) + notes.join('');
    setButton(s.enabled && s.eligible ? 'spin' : 'wait');
  }

  async function refresh() {
    info.innerHTML = '';
    setButton('wait');
    try {
      const s = await fetchStatus();
      if (s.rateLimited) return render({ error: true, rateLimited: true });
      cacheStatus(s);
      updateCount(s);
      render(s);
    } catch (e) {
      render({ error: true });
    }
  }

  // ---- 回す
  async function spin() {
    if (busy || !state || !state.loggedIn || !state.eligible || state.claimed) return;
    busy = true;
    setButton('wait');
    markWin(-1);
    if (!reduceMotion) startRun();
    let res = null;
    try {
      res = demo ? await demoSpin() : await request('/spin', 'POST');
    } catch (e) {
      res = null;
    }
    const body = res && res.body;
    const finish = (html, mode, k) => {
      const done = () => {
        busy = false;
        if (k != null && k >= 0) markWin(k);
        info.innerHTML = html;
        setButton(mode);
      };
      if (k != null && k >= 0) stopAt(angleFor(k, Math.random() * 2 - 1), done);
      else stopAt(angle + 20 + Math.random() * 300, done);
    };

    if (body && body.ok && body.result && !body.processing) {
      const r = body.result;
      const s = Object.assign({}, state, { claimed: true, result: r, streak: r.streak, balanceMinor: body.balanceMinor != null ? body.balanceMinor : state.balanceMinor });
      state = s;
      cacheStatus(s);
      updateCount(s);
      finish(resultHtml(s, r, !body.already) + rows(s), 'close', order.indexOf(r.index));
      return;
    }
    if (body && body.processing) return finish(p('lfc__note', T.processing), 'close');
    if (res && res.http === 401) {
      return finish(p('lfc__text', T.guest), 'login');
    }
    if (res && res.http === 403 && body && body.reason) {
      state = Object.assign({}, state, { eligible: false, reason: body.reason, availableAt: body.availableAt });
      cacheStatus(state);
      updateCount(state);
      return finish(rows(state) + p('lfc__text', reasonText(state, body.reason, body.availableAt)), 'wait');
    }
    if (res && res.http === 429) return finish(rows(state) + p('lfc__note', T.rateLimited), 'spin');
    // 付与の失敗・通信エラー: もう一度押せば、サーバー側で同じ結果の付与をやり直す
    return finish(rows(state) + p('lfc__note', T.spinError), 'spin');
  }

  // ---- 開く・閉じる
  function open() {
    if (!root.hidden) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('lfc-open');
    requestAnimationFrame(() => root.classList.add('is-open'));
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
    if (!busy) refresh();
  }
  function close() {
    if (root.hidden) return;
    showOdds(false);
    root.classList.remove('is-open');
    document.body.classList.remove('lfc-open');
    setTimeout(() => {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, reduceMotion ? 0 : 180);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-lfc-open]')) {
      e.preventDefault();
      open();
    }
  });
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-lfc-close]')) close();
  });
  oddsOpen.addEventListener('click', () => showOdds(true));
  oddsClose.addEventListener('click', () => showOdds(false));
  spinBtn.addEventListener('click', () => {
    if (spinBtn.getAttribute('data-mode') === 'close') close();
    else spin();
  });
  document.addEventListener('keydown', (e) => {
    if (root.hidden) return;
    if (e.key === 'Escape') {
      if (root.classList.contains('is-odds')) showOdds(false);
      else close();
      return;
    }
    if (e.key !== 'Tab') return;
    const items = Array.from(panel.querySelectorAll('button, a[href]')).filter((el) => !el.disabled && !el.closest('[hidden]') && el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // ---- ページを開いたとき: ヘッダーの (1) と、その日最初の1回だけ自動で開く
  function maybeAutoOpen(s) {
    if (!s || !s.enabled || !s.eligible || s.claimed) return;
    if (['cart', 'password', 'captcha'].indexOf(C.pageType) !== -1) return;
    const key = 'lfc:auto:' + C.customer;
    if (storageGet('localStorage', key) === s.day) return;
    if (document.querySelector('.cart-drawer.is-open, .signup-popup.is-open, .search-overlay:not([hidden])')) return;
    storageSet('localStorage', key, s.day);
    setTimeout(open, 600);
  }
  async function boot() {
    if (!C.loggedIn && !demo) return;
    if (demo === 'guest') return;
    const cached = demo ? null : cachedStatus();
    if (cached) {
      updateCount(cached);
      maybeAutoOpen(cached);
      return;
    }
    try {
      const s = await fetchStatus();
      if (s.rateLimited) return;
      cacheStatus(s);
      updateCount(s);
      if (demo) {
        if (/[?&]lf_bonus_demo=/.test(location.search)) open();
      } else {
        maybeAutoOpen(s);
      }
    } catch (e) {
      /* 取れなければ何も出さない */
    }
  }

  // ---- 見本（プレビュー専用）。実際の抽選・付与はしない
  const DEMO = {
    JPY: [[10, 6000], [20, 2500], [50, 1000], [100, 400], [500, 90], [1000, 10]],
    USD: [[10, 7000], [20, 2000], [50, 700], [100, 250], [500, 45], [1000, 5]],
  };
  function demoBase() {
    const currency = demo === 'usd' || C.currency === 'USD' ? 'USD' : 'JPY';
    const table = DEMO[currency];
    const left = demo === 'limit' ? 300 : Infinity;
    const total = table.reduce((a, x) => a + (x[0] <= left ? x[1] : 0), 0);
    return {
      ok: true,
      enabled: true,
      currency,
      prizes: table.map((x) => x[0]),
      odds: table.map((x) => ({ minor: x[0], probability: x[0] <= left ? x[1] / total : 0 })),
      rules: { expiresDays: 30, streakEvery: 7, streakBonusMinor: 100, monthlyCapMinor: currency === 'JPY' ? 3000 : 2000, minAccountAgeHours: 24 },
      limit: left < Infinity ? { by: 'cap', leftMinor: left } : null,
      table,
      left,
    };
  }
  function demoStatus() {
    const b = demoBase();
    if (demo === 'error') return Promise.reject(new Error('demo'));
    if (demo === 'guest') return Promise.resolve(Object.assign(b, { loggedIn: false }));
    const day = jstDay();
    const tomorrow = new Date(Date.parse(day + 'T00:00:00+09:00') + 864e5).toISOString();
    const s = Object.assign(b, {
      loggedIn: true,
      eligible: true,
      reason: null,
      availableAt: null,
      day,
      claimed: false,
      result: null,
      streak: demo === 'bonus' ? 6 : 3,
      balanceMinor: b.currency === 'JPY' ? 240 : 180,
      month: { usedMinor: demo === 'limit' ? 2700 : 120, capMinor: b.rules.monthlyCapMinor },
      budget: { limited: false, exhausted: false },
      upcoming: demo === 'spin' ? [{ currency: b.currency, amountMinor: b.currency === 'JPY' ? 60 : 45, dueAt: new Date(Date.now() + 12 * 864e5).toISOString(), order: '#1234' }] : [],
      resetAt: tomorrow,
    });
    if (demo === 'new') Object.assign(s, { eligible: false, reason: 'account_too_new', availableAt: new Date(Date.now() + 5 * 3600e3).toISOString() });
    if (demo === 'cap') Object.assign(s, { eligible: false, reason: 'monthly_cap', limit: null });
    let claim = null;
    try { claim = JSON.parse(storageGet('sessionStorage', 'lfc:demo-claim') || 'null'); } catch (e) { claim = null; }
    if (demo === 'claimed' && !claim) claim = { day, currency: s.currency, index: 2, baseMinor: 50, bonusMinor: 0, amountMinor: 50, streak: 4, note: null, status: 'granted' };
    if (claim && claim.day === day) Object.assign(s, { claimed: true, result: claim, streak: claim.streak });
    return Promise.resolve(s);
  }
  function demoSpin() {
    const b = demoBase();
    return new Promise((resolve) => {
      setTimeout(() => {
        const weights = b.table.map((x) => (x[0] <= b.left ? x[1] : 0));
        const total = weights.reduce((a, w) => a + w, 0);
        let r = Math.random() * total;
        let index = 0;
        for (let i = 0; i < weights.length; i++) {
          r -= weights[i];
          if (r < 0) { index = i; break; }
        }
        const streak = (state.streak || 0) + 1;
        const bonus = streak % 7 === 0 ? 100 : 0;
        const base = b.table[index][0];
        const result = { day: jstDay(), currency: b.currency, index, baseMinor: base, bonusMinor: bonus, amountMinor: base + bonus, streak, note: null, status: 'granted' };
        storageSet('sessionStorage', 'lfc:demo-claim', JSON.stringify(result));
        resolve({ http: 200, body: { ok: true, result, balanceMinor: (state.balanceMinor || 0) + base + bonus } });
      }, 700);
    });
  }

  boot();
})();
